export enum FileUploadStatus {
    Uploading = 'uploading',
    Uploaded = 'uploaded',
    Error = 'error'
}